var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1573_48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.64795 1.125C6.57676 1.01842 6.48038 0.93104 6.36734 0.87061C6.25431 0.81018 6.12812 0.778564 5.99995 0.778564C5.87177 0.778564 5.74558 0.81018 5.63255 0.87061C5.51952 0.93104 5.42314 1.01842 5.35195 1.125L0.101947 10.125C0.0361844 10.2389 0.00153173 10.3681 0.00146494 10.4996C0.00139815 10.6311 0.0359196 10.7604 0.101566 10.8743C0.167213 10.9883 0.261676 11.083 0.375479 11.149C0.489282 11.2149 0.618423 11.2497 0.749947 11.25H11.2499C11.3815 11.2497 11.5106 11.2149 11.6244 11.149C11.7382 11.083 11.8327 10.9883 11.8983 10.8743C11.964 10.7604 11.9985 10.6311 11.9984 10.4996C11.9984 10.3681 11.9637 10.2389 11.8979 10.125L6.64795 1.125Z",
    fill: "#20B5E3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1573_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.e4205d6e620b43e5e40d0d829d08ebbf.svg";
export { ForwardRef as ReactComponent };